// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export enum ClientEndpointMS2ReportingResolution {
	Directional = 0,
	Lane = 1,
}

export const ClientEndpointMS2ReportingResolutionDisplayNames: { [key in keyof typeof ClientEndpointMS2ReportingResolution]?: string} = {
	"Directional": "Direction code",
	0 : "Direction code",
	"Lane": "Lane number",
	1 : "Lane number",
}

export const getClientEndpointMS2ReportingResolutionDisplayName = (key: ClientEndpointMS2ReportingResolution | (keyof typeof ClientEndpointMS2ReportingResolution & string)) => {
	return ClientEndpointMS2ReportingResolutionDisplayNames[key];
}

